/**
 * This calculates progress percentage(0-100) based on start, end and current.
 * @param start
 * @param end
 * @param current
 * @returns {number}
 */
export function calculateCompletionPercent(start, end, current) {
  const completion = Math.min(Math.max((current - start) / (end - start), 0), 1)
  return isNaN(completion) ? 0 : Math.round(completion * 100)
}
